module.exports = __webpack_public_path__ + "img/calendar-ffffff.2cfcc600.svg";